export default [
    {
        path: '/cetak-qr-code',
        redirect: '/cetak-qr-code',
        name: 'cetakQrCode',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'cetakQrCodeIndex',
                component: () => import('@/views/cetakQrCode/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'cetakQrCode',
                    pageTitle: 'Cetak QR Code',
                    breadcrumb: [
                        {
                            text: 'Cetak QR Code',
                            active: true,
                        },
                    ],
                },
            },
        ]
    }
]